import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IdDescription } from 'tms-lib';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FabricProcessingFabricReferenceService extends BaseReferenceService {
  constructor() {
    super('FabricProcessingFabricReference');
  }
  getForFabric(productId: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForFabric/${productId}`);
  }
}
